import { Dividend } from '@benzinga/calendar-manager';
import CalendarService from '../lib/services/CalendarService';
import { injectLogos } from '../lib/utils';

const fetchDividends = (params = {}, injectTickersLogos = true, pageSize = 1000): Promise<Dividend[]> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getDividends(query).then(({ data }: { data: { dividends: Dividend[] } }) => {
    const items: Dividend[] = [];
    if (Array.isArray(data.dividends) && data.dividends.length) {
      return injectTickersLogos ? injectLogos(data.dividends) : data.dividends;
    }
    return items;
  });
};

export { fetchDividends };
